import React from "react";
import Layout from "./Layout";

function PageShell({ embedded = false, onLogout, children }) {
    if (embedded) {
        return <>{children}</>;
    }

    return <Layout onLogout={onLogout}>{children}</Layout>;
}

export default PageShell;
